import styled from 'styled-components';

export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
`;
export const Flex = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 2rem 0rem;
  img {
    margin-left: -3rem;
    z-index: 10;
  }
  @media (max-width: 570px) {
    width: 100%;
  }
  @media (max-width: 486px) {
    img {
      width: 50px;
      margin-left: -2rem;
    }
  }
`;

export const Title = styled.div`
  background-image: url(../subscription/Vector.png);
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 1rem 5rem;
  span {
    font-weight: bold;
    margin: 0 0.5rem;
    font-size: 1.4rem;
  }
  @media (max-width: 570px) {
    padding: 1rem 3rem;
  }
  @media (max-width: 486px) {
    padding: 1rem 2rem;
    font-size: 0.8rem;
    span {
      font-weight: bold;
      margin: 0;
      font-size: 1rem;
    }
  }
`;
export const RadioContainer = styled.div`
  display: flex;
  align-items: center;

  margin-bottom: 4rem;
  margin-top: 3rem;
  @media (max-width: 1028px) {
    flex-direction: column;
  }
`;
